import React, { forwardRef } from "react";

import MuiLoadingButton, {
  LoadingButtonProps as MuiLoadingButtonProps,
} from "@mui/lab/LoadingButton";
import { ButtonTypeMap } from "@mui/material";
import styled from "@mui/material/styles/styled";

export type { LoadingButtonProps as ButtonProps } from "@mui/lab/LoadingButton";

const LoadingButton = forwardRef(
  <P extends React.ElementType = ButtonTypeMap["defaultComponent"]>(
    props: MuiLoadingButtonProps<P>,
    ref: React.Ref<HTMLButtonElement | HTMLAnchorElement>
  ) => (
    <MuiLoadingButton
      disableRipple
      variant={props.variant ?? "contained"}
      ref={ref as any}
      {...props}
    />
  )
);

LoadingButton.displayName = "LoadingButton";

const StyledButton = styled(LoadingButton)({
  height: "46px",
  borderRadius: "8px",
  flexShrink: 0,
});

export default StyledButton;
